module.exports = __webpack_public_path__ + "img/note-red-used.15c07256.svg";